__turbopack_context__.v({
  "active": "_1iNVtG_active",
  "break": "_1iNVtG_break",
  "dark": "_1iNVtG_dark",
  "hoverable": "_1iNVtG_hoverable",
  "icon": "_1iNVtG_icon",
  "listWrapper": "_1iNVtG_listWrapper",
  "navItem": "_1iNVtG_navItem",
  "nested": "_1iNVtG_nested",
  "nestedTitleSpan": "_1iNVtG_nestedTitleSpan",
  "sectionTitle": "_1iNVtG_sectionTitle",
  "topNavSection": "_1iNVtG_topNavSection",
});
